export default {
  ratePlanType: {
    STANDARD: 'Standard',
    BAR: 'Kadar Terbaik Tersedia',
    CORPORATE: 'Korporat',
    MEMBER: 'Ahli',
    PACKAGE: 'Pakej',
    PROMOTIONAL: 'Promosi',
    OTA: 'OTA',
    WHOLESALE: 'Borong',
    NEGOTIATED: 'Dirunding',
    MIXED: 'Kadar campuran',
  },
} as const;
